/* Built In Imports */
/* External Imports */
import { Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { EnrollContextProvider } from '@ieo/Components/Form/ieo/context/enrollContext';
import { TranslationContext } from '@ieo/Components/Form/ieo/translation';
import { ThankYouStatusPage } from '@ieo/Components/ThankYou/ThankYouStatusPage';
import { ThankYouSuccessScreen } from '@ieo/Components/ThankYou/ThankYouSuccessScreen';
import { LoadingIndicator } from '@ieo/Components/ThankYou/ThankYouTakingLongerScreen';
import translationContent from '@ieo/Components/ThankYou/content.json';
import { usePageState } from '@ieo/Components/ThankYou/usePageState';
import { EnrollSectionUi } from '@ieo/Sections/EnrollSection';

/* Services */

/**
 *
 * @returns InvalidPage
 */
const InvalidPage = () => {
  return (
    <Flex justifyContent={'center'} alignItems={'center'} height={'full'}>
      Invalid Page
    </Flex>
  );
};

const ErrorPage = ({ pageState }) => {
  // console.log('ErrorPage', pageState);
  return (
    <Flex
      justifyContent={'center'}
      alignItems={'center'}
      height={'full'}
      py="30px"
      px="5%"
    >
      {pageState?.msg || 'There was an error with loading this page'}
    </Flex>
  );
};

const ThankYouPageContent = ({ bodyData, giftingFlow, lang }) => {
  const pageState = usePageState();
  if (pageState.status === 'error') {
    return <ErrorPage pageState={pageState} />;
  } else if (pageState.status === 'loading') {
    return <LoadingIndicator authStatus={pageState.authStatus} />;
  } else if (pageState.status === 'show-message') {
    return (
      <ThankYouStatusPage
        messageStatus={pageState.messageStatus}
        bodyData={bodyData}
      />
    );
  } else if (pageState.status === 'invalid') {
    return <InvalidPage />;
  }

  return (
    <ThankYouSuccessScreen
      bodyData={bodyData}
      giftingFlow={giftingFlow}
      lang={lang}
      {...pageState}
    />
  );
};

const IeoThankYouPageSection = ({
  pageData,
  lang,
  sectionContent,
  bodyData,
  giftingFlow,
  maxW,
}) => {
  // console.log({ pageData, lang, sectionContent });

  return (
    <TranslationContext.Provider value={translationContent}>
      <EnrollContextProvider>
        <EnrollSectionUi
          maxW={maxW}
          lang={lang}
          sectionContent={sectionContent}
        >
          <ThankYouPageContent
            lang={lang}
            bodyData={bodyData}
            giftingFlow={giftingFlow}
          />
        </EnrollSectionUi>
      </EnrollContextProvider>
    </TranslationContext.Provider>
  );
};

export default IeoThankYouPageSection;
